<div class="custom-html-container">
  @if (safeDisplayText) {
    <div [innerHTML]="safeDisplayText"></div>
  } @else {
    <div class="loading-placeholder" [innerHTML]="safePlaceHolder">
      <div class="loading-spinner"></div>
    </div>
  }
</div>
